import React from 'react'
import Header from '../../components/Header/Header';
import Dashboard from '../../components/Dashboard/Dashboard';
function DashboardPage() {
  return (
    <Header>
      <Dashboard />
    </Header>
  )
}

export default DashboardPage
